



















import {Vue, Component} from 'vue-property-decorator';
import {centerWinOptions} from '@/utils/commonUtils';
import {toI18n} from '@/utils/commonUtils';
import store from '@/store';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import { SaleMethodType } from 'ncp-api-supporter';

type AlertText = 
'saleStatus' | 
'frontDisplay' | 
'salePeriod' | 
'salePrice' | 
'immediateDiscount' | 
'promotionText' | 
'dutyInfo' | 
'promotionsChange' |
'priceComparison' | 
'commissionPurchase' |
'iconChange';
type BatchChangeTypes = 
'DELETE_GROUP_CODE' | 
'CHANGE_GROUP_CODE' | 
'DELIVERY_INFO' | 
'DUTY_INFO' | 
'PRODUCT_JUDGEMENT' | 
'FRONT_DISPLAY' | 
'IMMEDIATELY_DISCOUNT' | 
'SALE_PRICE' | 
'SALE_PERIOD' | 
'SALE_STATUS' | 
'PROMOTIONS_CHANGE' | 
'DIRECT_DISPLAY' | 
'PROMOTION_TEXT'|
'PRICE_COMPARISON_SITE'|
'COMMISSION_PURCHASE'|
'ICON'
type BatchChangeOptionsType = { name: string; value: BatchChangeTypes | 'SELECT' }[]

@Component({
  components: {
    CompSelectBox
  }})

export default class ProductListSlotLeft extends Vue {
  private selectedValue: BatchChangeTypes | 'SELECT' = 'SELECT';

  private readonly batchChangeOptions: BatchChangeOptionsType = [
    { name: this.toI18n('SELECT'), value: 'SELECT'},
    { name: this.toI18n('PLM_REGISTER_PRICE_COMPARISON_SITE'), value: 'PRICE_COMPARISON_SITE'},
    { name: this.toI18n('PLSLOTLEFT_BUTTON12'), value: 'DELETE_GROUP_CODE'},
    { name: this.toI18n('PLSLOTLEFT_BUTTON11'), value: 'CHANGE_GROUP_CODE'},
    { name: this.toI18n('PLSLOTLEFT_BUTTON7'), value: 'DELIVERY_INFO'},
    { name: this.toI18n('PLSLOTLEFT_BUTTON8'), value: 'DUTY_INFO'},
    { name: this.toI18n('PLSLOTLEFT_BUTTON9'), value: 'PRODUCT_JUDGEMENT'},
    { name: this.toI18n('COMMISSION_PURCHASE'), value: 'COMMISSION_PURCHASE'},
    { name: this.toI18n('ICON'), value: 'ICON'},
    { name: this.toI18n('PLSLOTLEFT_BUTTON2'), value: 'FRONT_DISPLAY'},
    { name: this.toI18n('PLSLOTLEFT_BUTTON5'), value: 'IMMEDIATELY_DISCOUNT'},
    { name: this.toI18n('PLSLOTLEFT_BUTTON4'), value: 'SALE_PRICE'},
    { name: this.toI18n('PLSLOTLEFT_BUTTON3'), value: 'SALE_PERIOD'},
    { name: this.toI18n('PLSLOTLEFT_BUTTON1'), value: 'SALE_STATUS'},
    { name: this.toI18n('PROMOTIONS_CHANGE'), value: 'PROMOTIONS_CHANGE'},
    { name: this.toI18n('PLSLOTLEFT_BUTTON10'), value: 'DIRECT_DISPLAY'},
    { name: this.toI18n('PLSLOTLEFT_BUTTON6'), value: 'PROMOTION_TEXT'},
  ];

  private handleBatchPopup() {
    const value = this.selectedValue;
  
    if (value === 'SELECT') {
      alert(this.toI18n('SELECT_BATCH_ITEM'))

      return;
    }

    value === 'PRICE_COMPARISON_SITE' && this.handleOpenPopup('priceComparison');
    value === 'DELETE_GROUP_CODE' && this.groupCodeRemove();
    value === 'CHANGE_GROUP_CODE' && this.groupCodeChange();
    value === 'DELIVERY_INFO' && this.onClickBatchModifyDeliveryInfo();
    value === 'DUTY_INFO' && this.commonHandle('dutyInfo');
    value === 'PRODUCT_JUDGEMENT' && this.onClickBatchJudgment();
    value === 'FRONT_DISPLAY' && this.commonHandle('frontDisplay');
    value === 'COMMISSION_PURCHASE' && this.handleOpenPopup('commissionPurchase');
    value === 'ICON' && this.handleOpenPopup('iconChange');
    value === 'IMMEDIATELY_DISCOUNT' && this.commonHandle('immediateDiscount');
    value === 'SALE_PRICE' && this.salePriceHandle('salePrice');
    value === 'SALE_PERIOD' && this.commonHandle('salePeriod');
    value === 'SALE_STATUS' && this.onClickBatchModifySaleStatus();
    value === 'PROMOTIONS_CHANGE' && this.commonHandle('promotionsChange');
    value === 'DIRECT_DISPLAY' && this.onClickBatchUrlDirectDisplay();
    value === 'PROMOTION_TEXT' && this.commonHandle('promotionText')
  }

  private handlePostMessage({ data }: MessageEvent) {
    data === 'SUCCESS' && store.commit('product/SET_SEARCHPRODUCTLIST', true);
  }

  private handleCommissionPurchasePopup(mallProductNos: string) {
    const checkedItems = this.tuiGridContainer.getCheckedItems();
    const saleMethodTypes = checkedItems.map(({ saleMethodType }) => saleMethodType) as SaleMethodType[];
    const openCommissionPurchasePopup = (productNos: string) => window.open(`/product/popup/commissionPurchase?mallProductNos=${productNos}`, 'commissionPurchase', centerWinOptions(900, 650));

    if (saleMethodTypes.includes('PURCHASE')) {
      if (confirm(this.toI18n('INCLUDE_PURCHASE'))) {
        const popup = openCommissionPurchasePopup(mallProductNos);
        popup.addEventListener('message', this.handlePostMessage)
      } else {
        const consignmentProductNos = checkedItems.map(({ saleMethodType, mallProductNo }) => {
          if (saleMethodType !== 'PURCHASE') {
            return mallProductNo;
          }
        }).filter((item) => item);

        if (consignmentProductNos.length) {
          const popup = openCommissionPurchasePopup(consignmentProductNos.join(','));
          popup.addEventListener('message', this.handlePostMessage);
        }
      }

      return;
    }

    const popup = openCommissionPurchasePopup(mallProductNos);
    popup.addEventListener('message', this.handlePostMessage);
  }

  //NOTE - 우선 가격비교사이트,수수료/매입가,아이콘에서만 사용함 (나중 통합어드민 작업 시 달라질 기획을 대비하기 위함)
  private openBatchPopup(type: AlertText, productNos: number[]) {
    const mallProductNos = productNos.join(',');

    if (type === 'priceComparison') {
      const popup = window.open(`/product/popup/priceComparison?mallProductNos=${mallProductNos}`, type, centerWinOptions(800, 470));
      popup.addEventListener('message', this.handlePostMessage)
    }

    if (type === 'commissionPurchase') {
      this.handleCommissionPurchasePopup(mallProductNos)
    }

    if (type === 'iconChange') {
      const mallNos = [...new Set(this.tuiGridContainer.getCheckedItems('mallNo').split(','))];

      if (mallNos.length > 1) {
        alert(`${this.toI18n('ICON')} ${this.toI18n('ICON_SAME_MALL')}`);

        return;
      }

      const popup = window.open(`/product/popup/iconChange?mallProductNos=${mallProductNos}&mallNo=${mallNos[0]}`, type, centerWinOptions(1000, 700));
      popup.addEventListener('message', this.handlePostMessage);
    }
  }

  private handleOpenPopup(type: AlertText) {
    const items = this.tuiGridContainer.getCheckedItems();
    const canChangeProductsNos = items.map(({ saleSettingStatusType, mallProductNo }) => {
      if (saleSettingStatusType !== 'PROHIBITION_SALE') {
        return mallProductNo;
      }
    }).filter((item) => item);
    const prohibitProductsNo = items.map(({ saleSettingStatusType, mallProductNo }) => {
      if (saleSettingStatusType === 'PROHIBITION_SALE') {
        return mallProductNo;
      }
    }).filter((item) => item);

    if (!items.length) {
      alert(this.toI18n('PLSLOTLEFT_ALERT1'));

      return;
    }

    if (!prohibitProductsNo.length) {
      this.openBatchPopup(type, canChangeProductsNos)

      return;
    }

    if (
      prohibitProductsNo.length && 
      canChangeProductsNos.length && 
      window.confirm(`${this.toI18n('SELECTED_ITEMS')} ${this.MODIFY_ALERT_TEXT[type]} ${this.toI18n('SOME_CHANGE_ITEM')}`)
    ) {
      this.openBatchPopup(type, canChangeProductsNos)

      return;
    }

    if (!canChangeProductsNos.length) {
      alert(`${this.toI18n('SELECTED_ITEMS_IS')} ${this.MODIFY_ALERT_TEXT[type]} ${this.toI18n('CANT_CHANGE_ITEM')}`);
    }
  }

  public toI18n(needToI18nStr: string, params?: string[]): string {
    return toI18n(this.$t('PRODUCT_PRODUCTLIST_' + needToI18nStr, params));
  }

  private tuiGridContainer: any;

  private MODIFY_ALERT = {
    toI18n: (needToI18nStr: string) => {
      return toI18n(this.$t('PRODUCT_PRODUCTLIST_' + needToI18nStr));
    },
    modifyType: '',
    getWarningMessage() {
      return `${this.toI18n('PLSLOTLEFT_MSG1')}${this.modifyType} ${this.toI18n('PLSLOTLEFT_MSG2')}`;
    },
    getProhibitMessage() {
      return `${this.toI18n('PLSLOTLEFT_MSG3')} ${this.modifyType} ${this.toI18n('PLSLOTLEFT_MSG4')}`;
    }
  };

  private MODIFY_ALERT_TEXT = {
    saleStatus: this.toI18n('PLSLOTLEFT_SALESTATUS'),
    frontDisplay: this.toI18n('PLSLOTLEFT_FRONTDISPLAY'),
    salePeriod: this.toI18n('PLSLOTLEFT_SALEPERIOD'),
    salePrice: this.toI18n('PLSLOTLEFT_SALEPRICE'),
    immediateDiscount: this.toI18n('PLSLOTLEFT_IMMEDIATEDISCOUNT'),
    promotionText: this.toI18n('PLSLOTLEFT_PROMOTIONTEXT'),
    dutyInfo: this.toI18n('PLSLOTLEFT_DUTYINFO'),
    delivery: this.toI18n('PLSLOTLEFT_DELIVERY'),
    groupManagementCode: this.toI18n('PLD_GROUP_MANAGEMENT_CODE'),
    promotionsChange: this.toI18n('PLSLOTLEFT_PROMOTION'),
    priceComparison: this.toI18n('PLM_REGISTER_PRICE_COMPARISON_SITE'),
    commissionPurchase: this.toI18n('COMMISSION_PURCHASE'),
    iconChange: this.toI18n('ICON'),
  };

  private MODIFY_ROUTE = {
    saleStatus: 'modifySaleStatus',
    frontDisplay: 'modifyFrontDisplay',
    salePeriod: 'modifySalePeriod',
    salePrice: 'modifySalePrice',
    immediateDiscount: 'modifyImmediateDiscount',
    promotionText: 'modifyPromotionText',
    dutyInfo: '/productDuty/modifyForm',
    promotionsChange: 'promotionsChange',
    priceComparison: 'priceComparison',
    commissionPurchase: 'commissionPurchase',
  };
  private MODIFY_SIZE = {
    saleStatus: [850, 480],
    frontDisplay: [800, 269],
    salePeriod: [1330, 500],
    salePrice: [880, 400],
    immediateDiscount: [680, 305],
    promotionText: [680, 300],
    dutyInfo: [1085, 830],
    promotionsChange: [800, 320],
    priceComparison: [800, 320],
    commissionPurchase: [800, 320],
  };

  private salePriceHandle(name: AlertText) {
    const mallProductNos = this.tuiGridContainer.getCheckedItems('mallProductNo') as string;
    const applyStatusType = this.tuiGridContainer.getCheckedItems('applyStatusType') as string;
    const saleSettingStatusType = this.tuiGridContainer.getCheckedItems('saleSettingStatusType') as string;
    const saleStatusType = this.tuiGridContainer.getCheckedItems('saleStatusType') as string;
    const optionType = this.tuiGridContainer.getCheckedItems('optionType') as string;
    const classType = this.tuiGridContainer.getCheckedItems('classType') as string;

    if (!mallProductNos) {
      alert(this.toI18n('PLSLOTLEFT_ALERT1')); //상품을 선택해주세요
      return;
    }

    const mallProductNosArr = mallProductNos.split(',');
    const applyStatusTypeArr = applyStatusType.split(',');
    const saleSettingStatusTypeArr = saleSettingStatusType.split(',');
    const saleStatusTypeArr = saleStatusType.split(',');
    const optionTypeArr = optionType.split(',');
    const classTypeArr = classType.split(',');
    let leftMallProductNos: string[] = [];

    mallProductNosArr.forEach((mallProductNo: string, index: number): void => {
      if (classTypeArr[index] === 'EVENT') {
        return;
      }

      if (applyStatusTypeArr[index] === 'REGISTRATION_READY' || saleSettingStatusTypeArr[index] === 'PROHIBITION_SALE' || saleStatusTypeArr[index] === 'END_SALE') {
        return;
      }

      if (optionTypeArr[index] === 'MAPPING') {
        return;
      }

      leftMallProductNos.push(mallProductNo);
    });

    if (mallProductNosArr.length === leftMallProductNos.length) {
      this.pop(leftMallProductNos, name);
    } else if (leftMallProductNos.length >= 1) {
      this.MODIFY_ALERT.modifyType = this.MODIFY_ALERT_TEXT[name];
      if (window.confirm(this.MODIFY_ALERT.getWarningMessage())) {
        // muliple mallProductNos
        this.pop(leftMallProductNos, name);
      }
    } else if (!leftMallProductNos.length) {
      this.MODIFY_ALERT.modifyType = this.MODIFY_ALERT_TEXT[name];
      alert(this.MODIFY_ALERT.getProhibitMessage());
    }
  }

  private onClickBatchModifySaleStatus() {
    const mallProductNos = this.tuiGridContainer.getCheckedItems('mallProductNo') as string;
    const applyStatusType = this.tuiGridContainer.getCheckedItems('applyStatusType') as string;
    const saleSettingStatusType = this.tuiGridContainer.getCheckedItems('saleSettingStatusType') as string;

    if (!mallProductNos) {
      alert(this.toI18n('PLSLOTLEFT_ALERT1')); //상품을 선택해주세요

      return;
    }
    
    const mallProductNosArr = mallProductNos.split(',');
    const applyStatusTypeArr = applyStatusType.split(',');
    const saleSettingStatusTypeArr = saleSettingStatusType.split(',');
    let leftMallProductNos: string[] = [];

    mallProductNosArr.forEach((mallProductNo: string, index: number): void => {
      //by 01.NHN-NcpAdmin-JspToVue/3201
      if (['REGISTRATION_READY', 'APPROVAL_READY', 'APPROVAL_REJECTION', 'SALE_AGREEMENT_READY', 'SALE_AGREEMENT_REJECTION'].includes(applyStatusTypeArr[index]) || saleSettingStatusTypeArr[index] === 'PROHIBITION_SALE') {
        return;
      }
      leftMallProductNos.push(mallProductNo);
    });

    if (mallProductNosArr.length === leftMallProductNos.length) {
      this.pop(leftMallProductNos, 'saleStatus');
    } else if (leftMallProductNos.length >= 1) {
      this.MODIFY_ALERT.modifyType = this.MODIFY_ALERT_TEXT['saleStatus'];
      if (window.confirm(this.MODIFY_ALERT.getWarningMessage())) {
        // muliple mallProductNos
        this.pop(leftMallProductNos, 'saleStatus');
      }
    } else if (!leftMallProductNos.length) {
      this.MODIFY_ALERT.modifyType = this.MODIFY_ALERT_TEXT['saleStatus'];
      alert(this.MODIFY_ALERT.getProhibitMessage());
    }
  }

  private commonHandle(name: AlertText) {
    const mallProductNos = this.tuiGridContainer.getCheckedItems('mallProductNo') as string;
    const applyStatusType = this.tuiGridContainer.getCheckedItems('applyStatusType') as string;
    const saleSettingStatusType = this.tuiGridContainer.getCheckedItems('saleSettingStatusType') as string;
    const saleStatusType = this.tuiGridContainer.getCheckedItems('saleStatusType') as string;

    if (!mallProductNos) {
      alert(this.toI18n('PLSLOTLEFT_ALERT1'));
      return;
    }

    const mallProductNosArr = mallProductNos.split(',');
    const applyStatusTypeArr = applyStatusType.split(',');
    const saleSettingStatusTypeArr = saleSettingStatusType.split(',');
    const saleStatusTypeArr = saleStatusType.split(',');
    let leftMallProductNos: string[] = [];

    mallProductNosArr.forEach((mallProductNo: string, index: number): void => {
      if (applyStatusTypeArr[index] === 'REGISTRATION_READY' || saleSettingStatusTypeArr[index] === 'PROHIBITION_SALE' || saleStatusTypeArr[index] === 'END_SALE') {
        return;
      }

      leftMallProductNos.push(mallProductNo);
    });

    if (mallProductNosArr.length === leftMallProductNos.length) {
      this.pop(leftMallProductNos, name);
    } else if (leftMallProductNos.length >= 1) {
      this.MODIFY_ALERT.modifyType = this.MODIFY_ALERT_TEXT[name];

      if (window.confirm(this.MODIFY_ALERT.getWarningMessage())) {
        this.pop(leftMallProductNos, name);
      }
    } else if (!leftMallProductNos.length) {
      this.MODIFY_ALERT.modifyType = this.MODIFY_ALERT_TEXT[name];

      alert(this.MODIFY_ALERT.getProhibitMessage());
    }
  }

  private pop(mallProductNos: string[], name: AlertText) {
    if (name === 'dutyInfo') {
      const params = mallProductNos
        .map((no: string): string => {
          return 'mallProductNo=' + no;
        })
        .join('&');
      window.open(`${this.MODIFY_ROUTE[name]}?mallProductsCnt=${mallProductNos.length}&type=batch&${params}`, name, centerWinOptions(this.MODIFY_SIZE[name][0], this.MODIFY_SIZE[name][1]));
    } else {
      window.open(`/product/popup/${this.MODIFY_ROUTE[name]}/${mallProductNos.join(',')}`, name, centerWinOptions(this.MODIFY_SIZE[name][0], this.MODIFY_SIZE[name][1]));
    }
  }

  private onClickBatchJudgment() {
    const mallProductNos = this.tuiGridContainer.getCheckedItems('mallProductNo') as string;
    const applyStatusType = this.tuiGridContainer.getCheckedItems('applyStatusType') as string;
    if (!mallProductNos) {
      alert(this.toI18n('PLSLOTLEFT_ALERT2')); //상품을 선택해 주세요.
      return;
    }
    const mallProductNosArr = mallProductNos.split(',');
    const nos: string[] = [];
    const targetStatus = ['APPROVAL_READY', 'AFTER_APPROVAL_READY'];
    applyStatusType.split(',').forEach((item, idx): void => {
      if (targetStatus.includes(item)) {
        nos.push(mallProductNosArr[idx]);
      }
    });

    if (nos.length) {
      window.open(`/product/judgement/batchConfirm/${nos.join(',')}`, 'batchJudgment', centerWinOptions(800, 450));
    } else {
      alert(this.toI18n('PLSLOTLEFT_ALERT3')); //선택하신 상품은 심사 불가능한 상품입니다. 상품을 다시 선택해주세요
    }
  }

  private onClickBatchUrlDirectDisplay() {
    const mallProductNos = this.tuiGridContainer.getCheckedItems('mallProductNo') as string;
    if (!mallProductNos) {
      alert(this.toI18n('PLSLOTLEFT_ALERT4')); //상품을 선택해 주세요.
      return;
    }
    const checkedRows = this.tuiGridContainer.getCheckedItems();
    const checkedMallProductNos = checkedRows.filter((item: any) => item.saleSettingStatusType !== 'PROHIBITION_SALE').map((item: any) => item.mallProductNo);
    if (!checkedMallProductNos.length) {
      alert(this.toI18n('PLSLOTLEFT_ALERT5')); //선택하신 상품은 프론트 노출 설정을 변경할 수 없습니다.
      return;
    } else if (checkedRows.length != checkedMallProductNos.length) {
      if (!confirm(this.toI18n('PLSLOTLEFT_ALERT6'))) {
        //선택하신 상품 중 프론트 노출 설정을 변경할 수 없는 상품이 있습니다. 해당 상품을 제외하고 변경하시겠습니까?
        return;
      }
    }

    window.open(`/product/popup/urlDirectDisplay/${checkedMallProductNos.join(',')}`, 'batchUrlDirectDisplay', centerWinOptions(663, 350));
  }

  private onClickBatchModifyDeliveryInfo() {
    const mallProductNos = this.tuiGridContainer.getCheckedItems('mallProductNo') as string;
    const applyStatusType = this.tuiGridContainer.getCheckedItems('applyStatusType') as string;
    const saleSettingStatusType = this.tuiGridContainer.getCheckedItems('saleSettingStatusType') as string;
    const saleStatusType = this.tuiGridContainer.getCheckedItems('saleStatusType') as string;
    const deliverable = this.tuiGridContainer.getCheckedItems('deliverable') as string;
    const optionType = this.tuiGridContainer.getCheckedItems('optionType') as string;
    const mallNos = this.tuiGridContainer.getCheckedItems('mallNo') as string;
    const partnerNos = this.tuiGridContainer.getCheckedItems('partnerNo') as string;
    // const deletables = this.tuiGridContainer.getCheckedItems('deletable') as string;
    const classType = this.tuiGridContainer.getCheckedItems('classType') as string;

    if (!mallProductNos) {
      alert(this.toI18n('PLSLOTLEFT_ALERT7')); //상품을 선택해주세요
      return;
    }
    const mallProductNosArr = mallProductNos.split(',');
    const applyStatusTypeArr = applyStatusType.split(',');
    const saleSettingStatusTypeArr = saleSettingStatusType.split(',');
    const saleStatusTypeArr = saleStatusType.split(',');
    const deliverableArr = deliverable.split(',');
    const optionTypeArr = optionType.split(',');
    const mallNoArr = mallNos.split(',');
    const partnerNoArr = partnerNos.split(',');
    // const deletableArr = deletables.split(',');
    const classTypeArr = classType.split(',');

    // 이벤트 / 등록대기 / 판매종료 / 판매금지 상품은 배송정보 수정 불가
    let partnerNo: any = 0,
      mallNo = 0,
      productNos = [];

    mallProductNosArr.forEach((productNo: any, index: number): void => {
      if (classTypeArr[index] === 'EVENT') {
        return;
      }

      if (
        'REGISTRATION_READY' === applyStatusTypeArr[index] ||
        'PROHIBITION_SALE' === saleSettingStatusTypeArr[index] ||
        'END_SALE' === saleStatusTypeArr[index] ||
        deliverableArr[index] === 'false'
      ) {
        // isProhibition = true;
        return;
      }

      if (optionTypeArr[index] === 'MAPPING') {
        return;
      }

      if (partnerNo !== 0 && partnerNo !== parseInt(partnerNoArr[index])) {
        partnerNo = -1;

        return;
      } else if (mallNo !== 0 && mallNo !== parseInt(mallNoArr[index])) {
        mallNo = -1;

        return;
      }

      partnerNo = parseInt(partnerNoArr[index], 10);
      mallNo = parseInt(mallNoArr[index], 10);

      productNos.push({mallProductNo: parseInt(productNo)});
    });

    if (partnerNo === -1 || mallNo === -1) {
      alert(this.toI18n('PLSLOTLEFT_ALERT8')); //배송정보 일괄 변경은 동일한 쇼핑몰과 파트너사 상품일 경우만 가능합니다. 다시 확인 후 상품을 선택해주세요

      return false;
    }

    const uriStr = `/${mallNo}/${partnerNo}/${productNos.map(item=>item.mallProductNo).join()}`;
    if (mallProductNosArr.length === productNos.length) {
      // 변경 불가 상품이 없는 경우
      window.open(`/product/popup/modifyDelivery${uriStr}`, 'modifyDelivery', centerWinOptions(1145, 800));
    } else if (mallProductNosArr.length !== productNos.length && productNos.length !== 0) {
      // 변경 불가 상품이 포함된 경우
      this.MODIFY_ALERT.modifyType = this.MODIFY_ALERT_TEXT.delivery;
      const result = confirm(this.MODIFY_ALERT.getWarningMessage());

      if (result) {
        window.open(`/product/popup/modifyDelivery${uriStr}`, 'modifyDelivery', centerWinOptions(1145, 800));
      }
    } else if (productNos.length === 0) {
      // 변경 불가 상품만 있는 경우
      this.MODIFY_ALERT.modifyType = this.MODIFY_ALERT_TEXT.delivery;
      alert(this.MODIFY_ALERT.getProhibitMessage());
    }
  }

  private onBatchSalePriceImmediateDiscount() {
    window.open('/product/popup/modifySalePriceAndImmediateDiscount', 'MSPAID', centerWinOptions(726, 336));
  }

  private async deleteProductsGroupManagementCodeMapping(mallNo: number, productNos: string): Promise<boolean> {
    try {
      const response = await this.$api.deleteProductsGroupManagementCodeMapping({
        params: {
          mallNo,
          productNos
        }
      });

      if (response?.status === 200) {
        return true;
      }
    }
    catch (e) {
      console.error(e);
    }

    return true;
  }

  private groupCodeChange() {
    const mallProductNos = this.tuiGridContainer.getCheckedItems('mallProductNo') as string;

    // 선택한 상품이 없는 경우
    if (!mallProductNos) {
      alert(this.toI18n('PLSLOTLEFT_ALERT1')); // 상품을 선택해주세요
      return;
    }

    const mallNos = this.tuiGridContainer.getCheckedItems('mallNo') as string;
    const arrMallNos = mallNos.split(',').reduce((unique, item) => {
      return unique.includes(item) ? unique : [...unique, item]
    }, []);

    // 선택한 상품들의 쇼핑몰이 다른 경우
    if (arrMallNos.length !== 1) {
      alert(this.toI18n('PLSLOTLEFT_ALERT9')); // 그룹관리코드는 동일 쇼핑몰 상품인 경우에만 일괄 설정이 가능합니다.
      return;
    }

    const groupManagementCode = this.tuiGridContainer.getCheckedItems('groupManagementCode') as string;
    const arrGroupManagementCode = groupManagementCode.split(',');

    const saleSettingStatusType = this.tuiGridContainer.getCheckedItems('saleSettingStatusType') as string;
    const arrSaleSettingStatusType = saleSettingStatusType.split(',');

    let arrMallProducts = mallProductNos.split(',').map((productNo, index) => {
      return {
        productNo,
        saleSettingStatusType: arrSaleSettingStatusType[index],
        groupManagementCode: arrGroupManagementCode[index]
      };
    });

    arrMallProducts = arrMallProducts.filter(p => p.saleSettingStatusType !== 'PROHIBITION_SALE');

    // 선택된 상품 전체가 판매 금지인 경우
    if (arrMallProducts.length === 0) {
      this.MODIFY_ALERT.modifyType = this.MODIFY_ALERT_TEXT['groupManagementCode'];
      alert(this.MODIFY_ALERT.getProhibitMessage());
      return;
    }

    // 선택된 상품 일부가 판매 금지인 경우
    if (arrMallProducts.length !== arrSaleSettingStatusType.length) {
      this.MODIFY_ALERT.modifyType = this.MODIFY_ALERT_TEXT['groupManagementCode'];
      if (!window.confirm(this.MODIFY_ALERT.getWarningMessage())) {
        return;
      }
    }

    // 이미 그룹관리코드가 설정되어 있는 경우
    if (arrMallProducts.filter(p => !!p.groupManagementCode).length > 0) {
      if (!window.confirm(this.toI18n('PLSLOTLEFT_ALERT10'))) {
        arrMallProducts = arrMallProducts.filter(p => !p.groupManagementCode);
      }
    }

    // 타겟 상품이 제거 되었는데 하나도 없는 경우
    if (arrMallProducts.length === 0) {
      alert(this.toI18n('PLSLOTLEFT_ALERT1')); // 상품을 선택해주세요
      return;
    }

    window.open(`/product/popup/edit/groupManagementCode?mallNo=${arrMallNos[0]}&productsNos=${arrMallProducts.map(p => p.productNo).join(',')}`, 'EditGroupManagementCode', centerWinOptions(850, 800));
  }

  private async groupCodeRemove() {
    const mallProductNos = this.tuiGridContainer.getCheckedItems('mallProductNo') as string;

    // 선택한 상품이 없는 경우
    if (!mallProductNos) {
      alert(this.toI18n('PLSLOTLEFT_ALERT1')); // 상품을 선택해주세요
      return;
    }

    const mallNos = this.tuiGridContainer.getCheckedItems('mallNo') as string;
    const arrMallNos = mallNos.split(',').reduce((unique, item) => {
      return unique.includes(item) ? unique : [...unique, item]
    }, []);

    // 선택한 상품들의 쇼핑몰이 다른 경우
    if (arrMallNos.length !== 1) {
      alert(this.toI18n('PLSLOTLEFT_ALERT9')); // 그룹관리코드는 동일 쇼핑몰 상품인 경우에만 일괄 설정이 가능합니다.
      return;
    }

    if (window.confirm(this.toI18n('PLSLOTLEFT_ALERT11', [arrMallNos.length + '']))) {
      const success = await this.deleteProductsGroupManagementCodeMapping(Number(arrMallNos[0]), mallProductNos);
      if (success) {
        alert(this.$t('ALERT_DELETE_SUCCESS'));
        store.commit('product/SET_SEARCHPRODUCTLIST', true);
      }
    }
  }

  private updateAdminBulk(){
    window.open('/product/popup/changeAdmin', 'ChangeAdmin', centerWinOptions(700, 500));
  }

  private mounted() {
    this.tuiGridContainer = this.$parent;
  }
}
